import React from 'react';
import PropTypes from 'prop-types';

import { StyledButton } from './CollectionBtnModalStyles';

var CollectionBtnModal = function CollectionBtnModal(props) {
  return React.createElement(
    StyledButton,
    { onClick: function onClick() {
        return props.openProductModal(props.product);
      } },
    'Choose Options'
  );
};

CollectionBtnModal.propTypes = {
  openProductModal: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired
};

export default CollectionBtnModal;